import React from 'react'

import '../styles/toggle.scss'

export default function Toggle(props){

    //const city link page
    const cityUrl = `https://www1.nyc.gov/site/planning/zoning/districts-tools/${props.url}.page`;


    //style toggle


    return(
        <div className="toggle">
            <label className="switch">
                <input id={props.id} 
                        type="checkbox" 
                        onClick={props.onClick} 
                        /> 
                <span className="slider" style={{backgroundColor: props.color}}/>
            </label>
            <h4 className="toggle-label">{props.label}</h4>
            {props.link === "true" ? 
                <a className="link" 
                    href={cityUrl}
                    rel="noreferrer noopener"
                    target="_blank">
                    guide
                </a> 
                : null}
        </div>
    )
}
